/**
 * Error模块配置
 * 定义错误模块的路由、权限和导航配置
 * @author AI Assistant
 * @date 2024-01-09
 */

import type { ModuleConfig } from '@/types/module'
import errorRoutes from './routes'

/**
 * Error模块配置
 */
const errorModule: ModuleConfig = {
  id: 'error',
  name: 'error',
  title: '错误页面',
  description: '系统错误页面模块，包含404、403、500等错误页面',
  version: '1.0.0',

  // 路由配置
  routes: errorRoutes,

  // 权限配置 - 错误页面无需权限控制
  permissions: [],

  // 导航配置 - 错误页面不显示在菜单中
  navigation: undefined
}

export default errorModule
